<ng-container>
  <ul ngbNav [(activeId)]="openTab" #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false" (navChange)="onNavChange($event)">
    <!-- Mipro MISONET scada-->
    <li [ngbNavItem]="'MISONET'" *ngIf="this.tenantConfig.influxMeasurements">
      <a ngbNavLink>{{ 'MISONET' | translate }} </a>
      <ng-template ngbNavContent>
        <qm-influx-graph
          class="w-100"
          #influxGraphMiso
          metadataType="misonet"
          [bucket]="this.tenantConfig.influxMeasurements.bucket"
          [measurement]="this.tenantConfig.influxMeasurements.measurement"
          [filterFields]="['tunnus', 'symboli', '_field']"
          [filterLabelFields]="{'tunnus': 'nimi', 'symboli': 'kuvaus'}"
          [filterDefaults]="{'_field': 'laskuri'}"
          windowField="_field"
          unitFieldName="yksikkö">
        </qm-influx-graph>
      </ng-template>
    </li>
    <!-- V2L laboratory system (V2L is the 'low-level system' -name) -->
    <!-- V2L system is authored and engineered by "Suomen vesiensuojeluyhdistysten liitto ry" -->
    <!-- In Finnish water business, there are multiple different laboratory systems in use -->
    <li [ngbNavItem]="'V2L'" *ngIf="this.tenantConfig.v2lMeasurements">
      <a ngbNavLink>{{ 'SVYL lab' | translate }} </a>
      <ng-template ngbNavContent>
        <qm-influx-graph
          class="w-100"
          #influxGraphV2l
          metadataType="v2l"
          [bucket]="this.tenantConfig.v2lMeasurements.bucket"
          [measurement]="this.tenantConfig.v2lMeasurements.measurement"
          [filterFields]="['NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.properties.nimi', 'NaytteenottoMatka.Naytteenotto.Nayte.NayteNimi', 'NaytteenottoMatka.Naytteenotto.Nayte.Analyysitulos.MaaritysmenetelmaNimi']"
          unitFieldName="NaytteenottoMatka.Naytteenotto.Nayte.Analyysitulos">
        </qm-influx-graph>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</ng-container>
<ng-container *ngIf="tenant === 14">
  <!-- VALMET DNA scada -->
  <!-- not part of tab pages as discussed with mr-908 -->
  <!-- At moment with Valmet, only neve tenant is supported, future tenants need work with "tagname's mappings / linkings" -->
  <qm-neve-measurements></qm-neve-measurements>
</ng-container>
